import { ShieldAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/button'
import { ROUTES } from '@/constants/routes'

type AccessDeniedStateProps = {
	title?: string
	description?: string
	onPrimaryAction?: () => void
	primaryLabel?: string
}

export const AccessDeniedState = ({
	title,
	description,
	onPrimaryAction,
	primaryLabel,
}: AccessDeniedStateProps) => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const handlePrimaryAction = () => {
		if (onPrimaryAction) {
			onPrimaryAction()
			return
		}

		navigate(ROUTES.DASHBOARD.HOME)
	}

	return (
		<div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-12 text-center">
			<div className="flex max-w-md flex-col items-center gap-4 rounded-2xl border border-kaefer-light-silver bg-white p-8 shadow-sm">
				<div className="rounded-full bg-kaefer-red/10 p-4 text-kaefer-red">
					<ShieldAlert className="size-8" />
				</div>
				<div className="space-y-2">
					<h1 className="text-2xl font-semibold text-kaefer-dark-grey">
						{title ?? t('errors.insufficient_permissions')}
					</h1>
					<p className="text-sm leading-6 text-muted-foreground">
						{description ?? t('errors.insufficient_permissionsDescription')}
					</p>
				</div>
				<Button
					onClick={handlePrimaryAction}
					className="bg-kaefer-dark-grey text-white hover:bg-kaefer-medium-grey"
				>
					{primaryLabel ?? t('common.back')}
				</Button>
			</div>
		</div>
	)
}
